import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {environment} from "../../environments/environment";


@Injectable({ providedIn: 'root' })
export class InvoiceService {

  backendUrl: string = environment.apiUrl;
  url_final: string

  constructor(private http: HttpClient) {
    
  }

  invoice_url(invoice_id, tipo) {
    this.url_final = this.backendUrl + "/rmsfe/invoice_url?tipo=" 
    this.url_final = `${this.url_final}${tipo}&invoice_id=${invoice_id}`;
    return this.http.get<any>(this.url_final, {observe: 'response'})
    .pipe(map(response => {
      // console.log("la api es");
      // console.log(response)
      return response;
    }));
  }


}